import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import { LuInfo } from "react-icons/lu";
import ModalBase from "../../../../../components/common/modal/ModalBase";
import TextInput from "../../../../../components/common/input/TextInput";
import { useOrderContext } from "../../../OrderPage";
import { useSelector } from "react-redux";
import { cloneDeep } from "lodash";

interface IInfo {
  data: any;
}

function Info({ data }: IInfo) {
  const { currentHd } = useSelector((state: any) => state.order);
  const { handleUpdateCurrentHd } = useOrderContext();
  const [openInfo, setOpenInfo] = useState<boolean>(false);
  const [note, setNote] = useState<string>();

  const handleCloseInfo = () => {
    setOpenInfo(false);
  };

  const handleSave = () => {
    const currentHdClone = cloneDeep(currentHd);
    if (currentHdClone?.details?.length <= 0) return;
    const detail = currentHdClone.details.find(
      (item: any) => item.ma_vt === data.ma_vt
    );
    if (!detail) return;
    detail.ghi_chu = note;
    handleUpdateCurrentHd({ details: currentHdClone?.details || [] });
    handleCloseInfo();
  };

  useEffect(() => {
    setNote(data?.ghi_chu || "");
  }, [data?.ghi_chu, openInfo]);

  return (
    <>
      <ModalBase
        width="400px"
        open={openInfo}
        handleClose={handleCloseInfo}
        title="Thông tin chi tiết"
        actions={[
          <Stack
            key={1}
            direction="row"
            alignItems="center"
            gap={1}
            justifyContent="flex-end"
          >
            <Button
              onClick={handleCloseInfo}
              size="small"
              variant="contained"
              color="error"
              sx={{
                color: "common.white",
                boxShadow: "none",
                textTransform: "none",
                "&:hover": { boxShadow: "none" },
              }}
            >
              Đóng
            </Button>
            <Button
              onClick={handleSave}
              size="small"
              variant="contained"
              color="primary"
              sx={{
                color: "common.white",
                boxShadow: "none",
                textTransform: "none",
                "&:hover": { boxShadow: "none" },
              }}
            >
              Lưu
            </Button>
          </Stack>,
        ]}
      >
        <Box sx={{ px: 2 }}>
          <Stack gap={2}>
            <Stack gap={0.5} direction="row" alignItems="center">
              <Typography sx={{ fontWeight: 600 }}>Đã chế biến:</Typography>
              <Typography sx={{ color: "error.main", fontWeight: 600 }}>
                {data?.sl_xuat || 0}
              </Typography>
            </Stack>
            <TextInput
              label="Ghi chú"
              direction="column"
              placeholder="Nhập ghi chú cho bếp"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </Stack>
        </Box>
      </ModalBase>
      <IconButton onClick={() => setOpenInfo(true)}>
        <LuInfo size={16} />
      </IconButton>
    </>
  );
}

export default Info;
